// ** React Imports
import { useContext } from "react";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

const useImagesCustomMaxWidth = ({
	isHomeCard = false,
	isHomeList = false,
} = {}) => {
	const { isPhone, isTablet, isDesktop, isGiant } =
		useContext(deviceTypeContext);

	/* MARCIN_P (DZ-2178: part 8.): Dodane sztywne breakpointy, ponieważ kontener z Masonry wypycha inne kontenery z prawej strony, które są obok niego poza stronę. Na mobile problem nie występouje bo kontener z Masonry ma zawsze 100% szerokości. Na dzień pisania komentarza takie szerokości były na datezone przy poszczególnych breakpointach. Innego sposobu, żeby to zrobić nie wymyśliłem bo nie potrafię sprawić, żeby kontener z Masonry dziedziczył z głownego wrappera (mamy bardzo dużo zagnieżdzeń itd.). 
	!!! WAŻNE: przy zmianie lub dodaniu breakpointów trzeba zmienić lub dodać breakpointy w funkcji poniżej !!! */
	let widthValue = "unset";

	if (isHomeCard) {
		if (isPhone) {
			widthValue = "100%";
		} else if (isTablet) {
			widthValue = "572px";
		} else if (isDesktop && !isGiant) {
			widthValue = "441px";
		} else if (isGiant) {
			widthValue = "731px";
		}
	} else if (isHomeList) {
		if (isPhone) {
			widthValue = "100%";
		} else if (isTablet) {
			widthValue = "599px";
		} else if (isDesktop && !isGiant) {
			widthValue = "839px";
		} else if (isGiant) {
			widthValue = "1129px";
		}
	} else {
		if (isPhone) {
			widthValue = "100%";
		} else if (isTablet) {
			widthValue = "599px";
		} else if (isDesktop && !isGiant) {
			widthValue = "839px";
		} else if (isGiant) {
			widthValue = "1130px";
		}
	}

	return widthValue;
};

export default useImagesCustomMaxWidth;
